import styled, { FlattenSimpleInterpolation, css } from 'styled-components'
import { HeightClass } from '~/utils/enum/classes'
import {
  AlignmentOptions,
  AreaLineColorSchemes,
  PlacementOptions
} from './type'

const navPlacementTransformer: Record<
  PlacementOptions,
  FlattenSimpleInterpolation
> = {
  default: css`
    position: relative;
  `,
  'fixed-bottom': css`
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9998; // Toast container's z-index is 9999, so we need to use a smaller number
  `,
  'fixed-top': css`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9998;
  `,
  'sticky-bottom': css`
    position: sticky;
    bottom: 0;
    margin-top: auto;
    z-index: 9998;
  `,
  'sticky-top': css`
    position: sticky;
    top: 0;
    z-index: 9998;
  `
}

export const Nav = styled.nav<{
  colorScheme?: AreaLineColorSchemes
  heightClass: HeightClass
  minorGutter?: boolean
  placement: PlacementOptions
}>`
  width: 100%;

  ${({ colorScheme, theme }) =>
    colorScheme &&
    `background-color: ${theme.areaLineColorSchemes[colorScheme].background};`};

  padding: ${({ theme, heightClass, minorGutter }) =>
    `${theme.areaLine[heightClass]?.verticalPadding} ${
      minorGutter ? '8px' : theme.areaLine[heightClass]?.horizontalPadding
    }`};
  height: ${({ theme, heightClass }) => theme.areaLine[heightClass]?.height};

  ${({ placement }) => navPlacementTransformer[placement]}

  @media (max-width: 768px) {
    padding: 8px;
  }
`

export const NavContent = styled.div<{
  colorScheme?: AreaLineColorSchemes
  heightClass: HeightClass
  minorGutter?: boolean
}>`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme, heightClass, minorGutter }) =>
    minorGutter ? '8px' : theme.areaLine[heightClass]?.spaceBetween};
  height: 100%;
  align-items: center;

  * {
    color: ${({ colorScheme, theme }) =>
      colorScheme ? theme.areaLineColorSchemes[colorScheme].text : '#303032'};
  }
`

export const CenterArea = styled.div<{ alignment: AlignmentOptions }>`
  flex: 1;
  display: flex;
  justify-self: center;
  place-content: ${({ alignment }) =>
    alignment === 'right' ? 'end' : alignment};
`

export const FixedPositionScenarioContainer = styled.div`
  position: relative;
  width: 100%;
  max-height: 400px;
  height: 400px;
  padding: 64px 0;
  overflow: auto;
`

export const StickyTopPositionScenarioContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: auto;
  border: 2px solid #333;
  padding: 24px;
  background-color: white;
  flex: 1;
  max-height: 400px;
  padding-top: 64px;
`

export const StickyBottomPositionScenarioContainer = styled.div`
  position: relative;
  width: 100%;
  background-color: inherit;
  display: flex;
  flex-direction: column;
  margin-top: 50vh;
  height: 600px;
`

export const BoxWrapper = styled.div`
  height: 300px;
  max-height: 300px;
  overflow: auto;
  border: 2px solid #333;
  background-color: #dedede;
`

export const FakeContent = styled.div`
  position: relative;
  height: 1200px;
  width: 100%;
  background-color: #b0e0e6;
  padding: 64px 0;
  z-index: 9997;
`
